import { useQuery } from '@tanstack/react-query';

import { fetchVideaPatientId } from '@/app/external/utils';

import { endpoints } from './endpoints';

interface UseGetVideaPatientParams {
  practicePatientId: string | null;
  primaryPracticeId: string | null;
  primaryOrganizationId: string | null;
}

export const useGetVideaPatient = ({
  practicePatientId,
  primaryPracticeId,
  primaryOrganizationId,
}: UseGetVideaPatientParams) => {
  return useQuery(
    [
      endpoints.getVideaPatientId,
      practicePatientId,
      primaryPracticeId,
      primaryOrganizationId,
    ],

    () => fetchVideaPatientId(practicePatientId, primaryPracticeId),
    {
      enabled: !!practicePatientId && !!primaryPracticeId,
      retryDelay: 5000,
      retry: 6,
    },
  );
};
